/**
 * The expiry of a feature flag in the Store.
 *
 * An expired Feature flag will be retrieved from the feature flag micro service again.
 *
 * By default, flags will expire after 15 minutes (900,000 milliseconds).
 */
export const FLAG_EXPIRY_BUFFER_IN_MS = 900000;

/**
 * The expiry of a failed feature flag in the Store.
 *
 * This expiry is used when a BE failed to resolve feature flag state.
 */
export const FAILED_FLAG_EXPIRY_BUFFER_IN_MS = 60000;

/**
 * The feature flag request timeout.
 */
export const FEATURE_FLAG_REQUEST_TIMEOUT_IN_MS = 10000;

/**
 * The feature flag facade timeout so it doesn't clash with the request timeout.
 */
export const FEATURE_FLAG_FACADE_TIMEOUT_IN_MS = FEATURE_FLAG_REQUEST_TIMEOUT_IN_MS + 1000;
